import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-40344523")
const _hoisted_1 = { class: "tools" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HomeButton = _resolveComponent("HomeButton")!
  const _component_LearnMoreButton = _resolveComponent("LearnMoreButton")!
  const _component_TagsButton = _resolveComponent("TagsButton")!
  const _component_AssetTypeFilter = _resolveComponent("AssetTypeFilter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HomeButton, { onResetToDefault: _ctx.resetToDefault }, null, 8, ["onResetToDefault"]),
    _createVNode(_component_LearnMoreButton),
    _createVNode(_component_TagsButton, { onResetForTags: _ctx.resetForTags }, null, 8, ["onResetForTags"]),
    _createVNode(_component_AssetTypeFilter, { onHandleAssetTypeChange: _ctx.handleAssetTypeChange }, null, 8, ["onHandleAssetTypeChange"])
  ]))
}